import React from 'react';
import { useSelector } from 'react-redux';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import Select, { SelectOption } from 'common/components/pickers/Select';

import { useDispatch } from 'react-redux';
import * as UserSelectors from 'selectors/UserSelectors';
import * as UserActions from 'actions/UserActions';

interface Props {}
const ActiveLocationSelect = (props: Props) => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const userLocations = useSelector(UserSelectors.userLocations);
	const activeLocationId = useSelector(UserSelectors.userActiveLocationId);

	const options: SelectOption[] = userLocations.map((location) => ({
		label: location.name,
		id: location.id,
	}));

	return (
		<Select.Single
			value={activeLocationId}
			onChange={(locationId) => {
				if (!locationId) return;
				dispatch(UserActions.setActiveLocationId(locationId));
			}}
			options={options}
			variant="minimal"
			hideEmptyOption
			customClasses={{
				optionLabel: classes.optionLabel,
				selectedValue: classes.optionLabel,
			}}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		optionLabel: {
			fontSize: '1.4rem',
			fontWeight: 500,
		},
	}),
);

export default ActiveLocationSelect;
